// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1kjlq","left":"InfoRow_left__vv-Jf"};